<template>
  <div class="dialogCreateFile">
    <dialogTitle name="方案信息" />
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="需求类型">
        <span>{{ itemByNeedNo.channelTypeCode }}</span>
      </el-form-item>
      <el-form-item label="企业名称" prop="companyName">
        <el-input
          v-model="ruleForm.companyName"
          placeholder="请输入企业名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="网文类型" prop="licenseType">
        <el-select
          v-model="ruleForm.licenseType"
          placeholder="请选择网文类型"
          @change="wangwenchange"
        >
          <el-option
            v-for="item in wangwenOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="办理类型" prop="actionType">
        <el-select
          v-model="ruleForm.actionType"
          placeholder="请选择办理类型"
          @change="banlichange"
        >
          <el-option
            v-for="item in banliOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公司区域" prop="area">
        <el-select
          v-model="ruleForm.area"
          placeholder="请选择公司区域"
          @change="regionchange"
        >
          <el-option
            v-for="(item, index) in regionList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="办理价格">
        <p class="price">￥{{ (Number(price) / 100).toFixed(2) }}</p>
      </el-form-item>
      <!-- <el-form-item label="公司地址" prop="city">
				<v-distpicker
					v-model="ruleForm.city"
					@province="selectProvince"
					@city="selectCity"
				/>
			</el-form-item>
			<el-form-item label="" prop="address">
				<el-input
					v-model="ruleForm.detailAddress"
					placeholder="请输入详细地址"
				></el-input>
			</el-form-item> -->
    </el-form>
    <div class="demantFromFooter">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >提交方案</el-button
      >
    </div>
  </div>
</template>

<script>
//
import dialogTitle from "./dialogtitle";
import { ncSubmitSolution, getProductPrice } from "@/api/alicp.js";
export default {
  props: ["itemByNeedNo"],
  components: {
    dialogTitle,
  },
  data() {
    return {
      ruleForm: {
        companyName: "", //企业名称
        licenseType: "",
        actionType: "",
        area: "",
      },
      price: 0,
      solutionCity: "",
      rules: {
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        licenseType: [
          {
            required: true,
            message: "请输入网文类型",
            trigger: "blur",
          },
        ],
        actionType: [
          {
            required: true,
            message: "请输入办理类型",
            trigger: "blur",
          },
        ],
        area: [
          {
            required: true,
            message: "请选择公司区域",
            trigger: "change",
          },
        ],
      },
      regionList: [
        "全国"
      ],
      wangwenOptions: [
        {
          value: "动漫",
          label: "动漫",
        },
        {
          value: "音乐",
          label: "音乐",
        }
      ],
      banliOptions: [
        {
          value: "新办",
          label: "新办",
        },
        // {
        //   value: "变更",
        //   label: "变更",
        // },
        // {
        //   value: "续期",
        //   label: "续期",
        // },
      ],
    };
  },
  mounted() {},
  methods: {
    selectProvince(a) {
      this.ruleForm.province = a.value;
      this.ruleForm.city = "";
    },
    selectCity(a) {
      this.ruleForm.city = a.value;
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      let obj = {
        CompanyName: this.ruleForm.companyName,
        LicenseType: this.ruleForm.licenseType,
        ActionType: this.ruleForm.actionType,
        Area: this.ruleForm.area,
        IcpType: this.itemByNeedNo.channelTypeCode,
        SolutionPrice: this.price,
        SolutionCity: this.solutionCity,
      };
      console.log(obj, "obj");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("tolkParent", { loading: true, dialog: true });
          ncSubmitSolution(obj, this.$route.query.needNo).then((res) => {
            console.log(res);
            if (res.status == 0) {
              this.$message({
                message: "提交方案成功！",
                type: "success",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: false,
              });
              this.ruleForm = {
                companyName: "", //企业名称
                licenseType: "",
                actionType: "",
                area: "",
              };
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: true,
              });
            }
          });
        } else {
          this.$message({
            message: "请完善信息",
            type: "warning",
          });
          return false;
        }
      });
    },
    //公司区域
    regionchange(val) {
      var prince =  this.ruleForm.area;
      console.log(val, "var+++=");
      console.log(this.ruleForm.area, "公司区域");
      let params = {
        channelItemCode: this.itemByNeedNo.channelTypeCode,
        pathCode: "/zzfw/bdnc/",
        city: this.ruleForm.area,
      };
      getProductPrice(params).then((res) => {
        console.log("params+++",params)
        console.log("res+++",res)
        if (res.status == 0) {
          this.price = res.data.price;
          this.solutionCity = res.data.city;
        } else {
          this.price = 0;
        }
      });
    },
    //网文类型
    wangwenchange(val) {
      var prince = this.ruleForm.licenseType;
      console.log(prince, "网文类型");
      let params = {
        channelItemCode: this.itemByNeedNo.channelTypeCode,
        pathCode: "/zzfw/bdnc/",
        city: prince,
      };
      getProductPrice(params).then((res) => {
        if (res.status == 0) {
          this.price = res.data.price;
          this.solutionCity = res.data.city;
        } else {
          this.price = 0;
        }
      });
    },
    //办理类型
    banlichange(val) {
      var prince = this.ruleForm.actionType;
      console.log(prince, "办理类型");
      let params = {
        channelItemCode: this.itemByNeedNo.channelTypeCode,
        pathCode: "/zzfw/bdnc/",
        city: prince,
      };
      getProductPrice(params).then((res) => {
        if (res.status == 0) {
          this.price = res.data.price;
          this.solutionCity = res.data.city;
        } else {
          this.price = 0;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialogCreateFile {
  width: 100%;
  .el-form {
    width: 100%;
    .el-form-item {
      .el-form-item__content {
        .el-input {
          width: 400px;
          margin-right: 10px;
        }
        & > .el-input {
          width: 400px;
        }
        .el-input__inner:focus {
          border-color: #ff8a01;
        }
        .price {
          font-size: 18px;
          color: #ff8a01;
          font-weight: 500;
        }
      }
    }
  }
  .distpicker-address-wrapper select {
    width: 190px;
  }
  .distpicker-address-wrapper select:nth-child(3) {
    display: none;
  }
  .demantFromFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
